import React from "react";

const ROLE_LABEL = {
    super_admin: "Super Admin",
    admin: "Admin",
    manager: "Manager",
    customer: "Customer",
};

const ROLE_CLASSES = {
    super_admin: "bg-amber-100 text-amber-900 ring-amber-200",
    admin: "bg-blue-100 text-blue-900 ring-blue-200",
    manager: "bg-violet-100 text-violet-900 ring-violet-200",
    customer: "bg-emerald-100 text-emerald-900 ring-emerald-200",
};

export function RoleBadge({ role }) {
    return (
        <span
            data-testid={`role-badge-${role}`}
            className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold ring-1 ring-inset ${ROLE_CLASSES[role] || "bg-slate-100 text-slate-800 ring-slate-200"}`}
        >
            {ROLE_LABEL[role] || role}
        </span>
    );
}
